import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Loader from '../../parts/Loader';
import RenderErrors from '../../elements/RenderErrors';
import helpers from '../../../services/helpers';
import Swal from 'sweetalert2';
import { getApiData, postApiData } from '../../../services/apiService';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
 
export default function TransactionFormModal ({
        show_modal = false, 
        id = '', 
        close_modal={}, 
        handleSave={}
    }){
        
    let default_data = {
        "id": "",
        "first_name": "",
        "last_name": "",
        "position_id": ""
    }
    const [record_loaded, setRecordLoaded] = useState(0);
    const [form_data, setFormData] = useState(default_data);
    const [loading, setLoading] = useState(0);
    const [errors, setErrors] = useState([]);
    const [positions, setPositions] = useState([]);
   
    useEffect(() => {
        setErrors([])

        if(show_modal && id){
            setLoading(1)
            fetchData(id)
        }
        else if(show_modal && !id){
            setFormData(default_data)
            fetchPosition()
        }
    }, [show_modal, id]);

    async function fetchData(id){
        if(!id){
            return
        }

        let endpoint = helpers.createUrl(`V1/hrms/employees/${id}`)
        const res = await getApiData(endpoint, false)
        
        if(res.status === 'error'){
            Swal.fire({
                title: "Error!",
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    reset();
                    close_modal(0);
                }
            })
        }
        else{
            setFormData(res)
            //setLoading(0)
            //setRecordLoaded(1)
            fetchPosition()
        }
    }

    async function fetchPosition(){
        let endpoint = helpers.createUrl(`V1/hrms/positions`)
        const res = await getApiData(endpoint, false)
        
        if(res.status === 'error'){
            Swal.fire({
                title: "Error!",
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    reset();
                    close_modal(0);
                }
            })
        }
        else{
            setPositions(res)
            setLoading(0)
            setRecordLoaded(1)
        }
    }

    function validateForm(){
        let new_errors = {...errors}

        if(!form_data.first_name){
            new_errors['first_name'] = ['The first name field is required.']
        }
        else{
            delete new_errors['first_name'];
        }

        if(!form_data.last_name){
            new_errors['last_name'] = ['The last name field is required.']
        }
        else{
            delete new_errors['last_name'];
        }

        if(!form_data.position_id){
            new_errors['position_id'] = ['The position id field is required.']
        }
        else{
            delete new_errors['position_id'];
        }

        setErrors(new_errors);

        return new_errors;
    }

    async function handleSubmit(e) {
        const validate = validateForm();
        
        if(Object.keys(validate).length){
            Swal.fire({
                text: 'Please complete all required fields in the form.',
                icon: "error",
                confirmButtonText: "OK",
            })
            return
        }
        
        setLoading(1)

        let endpoint = helpers.createUrl(`V1/hrms/employees/create`)
        if(id && record_loaded){
            endpoint = helpers.createUrl(`V1/hrms/employees/${id}`)
        }
        const res = await postApiData(endpoint, form_data)

        if(res.error_code){
            if(res.data){
                setErrors( res.data );
            }else{
                setErrors([])
            }
            setLoading(0)
        }
        else{
            Swal.fire({
                title: "Success",
                text: res.message,
                icon: "success",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    close_modal(0);
                    handleSave(form_data);
                    return;
                }
            })
        }
    }
    
    
    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            value = 0;
            
            if (e.target.checked) value = 1;
        }
        else if(name === 'discount_rate'){
            if(value){
                value = Number(value).toFixed(2)
            }
        }

        let new_state = { [name]: value }

        setFormData({ ...form_data, ...new_state });
    }

    function inputChangeEnter(e) {
        if (e.key === "Enter"){
            setErrors([])
            if(!form_data.discount_name){
                setErrors(
                    {"discount_name":["The discount name name field is required."]}
                )
                return;
            }

            handleSubmit()
        }
    }

    function handleClose(e) {
        e.preventDefault();
        reset();
        close_modal(0);
    }

    function reset(){
        setFormData(default_data)
    }

    return (
        <>
            <Modal show={show_modal}>
                <Modal.Header className='pt-3 pb-3'>
                    <h5 className='mb-0'>Employee Information</h5>
                    <a href="#" className='btn btn-danger btn-sm'onClick={handleClose}><i className="fas fa-times"></i></a>
                </Modal.Header>
                <Modal.Body  style={{position: 'relative'}}>
                    <Loader isLoading={loading}/>

                    <div className="row mb-4">
                        <div className="col-md-12">
                            <label>Position<span className="text-danger">*</span></label>
                            <Dropdown  
                                name='position_id'
                                value={form_data.position_id} 
                                onChange={inputChange} 
                                options={positions} 
                                optionLabel="position_name" 
                                optionValue="id" 
                                placeholder="Select Position" 
                                className="w-100" 
                                checkmark={true} 
                                highlightOnSelect={false}
                                showClear
                                filter 
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="position_id" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>

                    <div className="row mb-4">
                        <div className="col-md-12">
                            <label>First Name<span className="text-danger">*</span></label>
                            <InputText
                                id="first_name" 
                                name="first_name" 
                                value={form_data.first_name}
                                tagClass="form-control mb-0"
                                placeholder="First Name"
                                onChange={inputChange}
                                autoFocus={true}
                                onKeyDown={inputChangeEnter}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="first_name" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>

                    <div className="row mb-4">
                        <div className="col-md-12">
                            <label>Last Name<span className="text-danger">*</span></label>
                            <InputText
                                id="last_name" 
                                name="last_name" 
                                value={form_data.last_name}
                                tagClass="form-control mb-0"
                                placeholder="Last Name"
                                onChange={inputChange}
                                autoFocus={true}
                                onKeyDown={inputChangeEnter}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="last_name" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type='button' className='btn btn-success ml-3 ' onClick={(e) => handleSubmit()} disabled={loading}><i className="fas fa-check mr-2" />Save</button>  
                </Modal.Footer>
            </Modal>
        </>
    )
}